import routes from './routes';
import VueRouter from 'vue-router';

export function getRouter(routes) {
    const router = new VueRouter({
        routes,
        mode: 'history',
        scrollBehavior() {
            return { x: 0, y: 0 };
        },
    });

    router.beforeEach((to, from, next) => {
        function hasQueryParams(route) {
            return !!Object.keys(route.query).length;
        }
        if (!hasQueryParams(to) && hasQueryParams(from)) {
            if (Object.keys(from.query).length === 1 && from.query.page) {
                next();
                return;
            }
            const toWithQuery = Object.assign({}, to, { query: from.query });
            next(toWithQuery);
        } else {
            next();
        }
    });

    return router;
}

export const router = getRouter(routes);
